// Máscaras BR para inputs

export const maskCNPJ = (v) => {
  const d = String(v || "").replace(/\D/g, "").slice(0, 14);
  return d
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2");
};

// (99) 9999-9999 ou (99) 99999-9999
export const maskPhone = (v) => {
  const d = String(v || "").replace(/\D/g, "").slice(0, 11);
  if (d.length <= 10) {
    return d
      .replace(/^(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{4})(\d)/, "$1-$2");
  }
  return d
    .replace(/^(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{5})(\d)/, "$1-$2");
};

export const maskCEP = (v) => {
  const d = String(v || "").replace(/\D/g, "").slice(0, 8);
  return d.replace(/^(\d{5})(\d)/, "$1-$2");
};

export const onlyDigits = (v) => String(v || "").replace(/\D/g, "");

/**
 * Consulta ViaCEP e retorna { address, neighborhood, city, state } ou null.
 * Não lança — devolve null em qualquer falha.
 */
export const lookupCEP = async (cep) => {
  const digits = onlyDigits(cep);
  if (digits.length !== 8) return null;
  try {
    const r = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
    if (!r.ok) return null;
    const d = await r.json();
    if (d.erro) return null;
    return {
      address: d.logradouro || "",
      neighborhood: d.bairro || "",
      city: d.localidade || "",
      state: d.uf || "",
    };
  } catch {
    return null;
  }
};
